export const terms_and_condition = ` 
			<center><h1 class="p-1">Terms and Conditions <br/>("Terms of Services")</h1></center>
			<div class="text-center">
				Effective date : July 1, 2021x
			</div>
			<p>
				In this Terms of Services, the expressions below shall have the following meanings:
			</p>
			<p>
				<strong>"SKOR Creative"</strong> means a mobile application and/or website operated by Us.
			</p>
			<p>
				<strong>"Service"</strong> mean services available at SKOR Creative which is operated by Us and link in the provision of the Service.
			</p>
			<p>
				<strong>"User(s)/You/Your"</strong> means everyone who uses the Services by having an account.
			</p>
			<p>
				<strong>"Account"</strong> means the User’s account registered in SKOR Creative.
			</p>
			<p>
				<strong>"We/Us/Our"</strong> means the SKOR Creative team.
			</p>
			<p>
				<strong>“Personal Data”</strong> means any information or data regarding or relating to the User that is submitted, given or installed by the User in SKOR Creative, including but not limited to name, gender, place/date of birth, marital status, address, e-mail address, and/or telephone number.
			</p>
			<p>
				<strong>"Privacy Policy"</strong> means Our treatment to information regarding Personal Data used in SKOR Creative and the Service.
			</p>
			<p>
				By using the Service, the User accepts and agrees to be subject to the Terms of Services and Privacy Policy.
			</p>
			<p>
				</p><ol>
						<li><strong>General</strong>
							<ol>
								<li>
									By pressing/clicking the "Register"/"Sign Up" button, You directly, consciously and voluntarily have registered with SKOR Creative, and have agreed to and are subject to all provisions contained in this Terms of Services, so that the Terms of Services will be legally binding to You. If You do not agree to the Terms of Services, You can choose to stop using the services contained in the Service. Whenever You wish to terminate Your legal relationship and/or commitment to this Terms of Services, You can do so by deleting Your Account and no longer accessing and using the Service.
									<br>
									<br>
									</li>
								<li>
									When You register yourself with the application, You declare and warrant to SKOR Creative that You are in the legal age according to the prevailing law at the time of Your registration, and therefore You have the legal capacity to make a legally binding agreement, and You covenant to SKOR Creative that:
									<br>
									<br>
								<ol>
									<li>You will provide SKOR Creative with correct, accurate, updated and complete information and will update Your information as necessary to maintain the correctness, completeness and accuracy of the information; and</li>
									<li>Your registration and use of the Service are carried out with a real email address owned and used properly by yourself and not restricted, hindered or prohibited by law.</li>
								</ol>
								</li>
							</ol>
					</li>
						<li>
							<strong>Property and Proprietary Materials</strong>
							<p>
								The SKOR Creative’s services and website and mobile application are the property of SKOR Creative. In spite of the foregoing, all texts, images, sounds, music, signs, logos, compilations in the form of a collection, arrangement and series of information; and other content in SKOR Creative which allow the User to post content, including messages, reviews, photos, images, folders, data, text, and other types of works (the "User Content") and all software contained on the SKOR Creative’s website or mobile application used by SKOR Creative in providing the Service ("Software") owned by SKOR Creative are protected by copyright and other intellectual property rights laws.
							</p>
						</li>
						<li>
							<ol>
								<strong>SKOR Creative’s Service</strong>
								<br>
									<br>
								<li>
									SKOR Creative aims to:
									<br>
										<br>
									<ol>
										<li>Improve the User’s activities by giving added value to the User and invites the User to actively participate in the Service activities.</li>
										<li>Connect You with all Users, where We will help You to find and connect with other Service Users.</li>
										<li>Help You to find content, products and services offered by third parties in collaboration with the Service by displaying advertisements, campaigns and other sponsored content.</li>
										<li>
											Combat dangerous behavior and protect and support the Users, where the Users are willing to use the Services supported by the SKOR Engagement Platform that employs a special team that develops sophisticated technical systems to detect misuse of the Service, behavior that hurts other people, and situations that might help to support and protect the Users. If We find such content or behavior, We can take adequate action, for example offering assistance, removing content, suspending Account if it is proven violating the applicable laws, including but not limited to the Law Number 11 of 2008 on Information and Electronic Transactions as amended by the Law Number 19 of 2016 (or its amendment from time to time) and the relevant implementing regulations.
										<br>
											<br>
										</li>
									</ol>
								</li>
								<li>
									We reserve the right to suspend or terminate your registration or your access to the Service if You violate this Terms of Services. You are fully responsible for Your own registration and all use of the Service. You shall not share your password or use the Service using third party registration.
									<br>
									<br>
								</li>
								<li>
									To provide the Service, SKOR Creative needs to collect and use Personal Data, SKOR Creative describes them in detail in the Privacy Policy.
									<br>
									<br>
								</li>
								<li>
									Our Service does not address anyone under the age of 18 ("Children"). We do not knowingly collect personally identifiable information from anyone under the age of 18. If You are a parent or guardian and You are aware that Your Child has provided us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from Children without verification of parental consent, We take steps to remove that information from Our servers.
									<br>
									<br>
								</li>
								<li>
									Our Service may contain links to other sites that are not operated by Us. If You click a third party link, You will be directed to that third party's site. We strongly advise You to review the privacy policy of every site You visit. We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
									<br>
									<br>
								</li>
							</ol>
						</li>
						<li>
							<ol>
								<strong>Your commitment to SKOR Creative</strong>
								<br>
									<br>
								<li>
									SKOR Creative provides the Services to You and other Users to achieve the objectives of SKOR Creative as mentioned above. In achieving such objectives, SKOR Creative needs You to make a commitment with SKOR Creative as follows:
								</li>
								<li>
									You shall:
									<br>
										<br>
									<ol>
										<li>Verify that You are a User;</li>
										<li>Use the same name as You use every day and not use a pseudonym;.</li>
										<li>Provide true and accurate information regarding yourself;</li>
										<li>
											Create one Account of Your own and use your timeline for Your own purposes;
										</li>
										<li>
											Not share Your password, grant access to Your account to any persons, or transfer Your Account to any persons. SKOR Creative shall not be responsible if Your Account and password have changed hands or transferred to other persons due to the User’s negligence.
										<br>
											<br>
										</li>
									</ol>
								</li>
								<li>
									SKOR Creative seeks to make the application widely available to all Users, but You may not use the SKOR Engagement Platform if:
									<br>
										<br>
									<ol>
										<li>You are a convicted felon for crime of terrorism or sexual offense/abuse.</li>
										<li>We previously have deactivated Your Account due to Your violation of Our provisions and policies.</li>
										<li>You are not allowed to receive Our products, services, or software pursuant to the applicable law.</li>
									</ol>
								</li>
								<li>
									What can You share and do in SKOR Creative:
									<br>
										<br>
									<ol>
										<li>
											We want the Users who use SKOR Creative to express themselves and share important and/or useful content for the Users, without prejudice to the security and safety of other Users and the integrity of the Users itself. Therefore, You agree not to interact in the manner described below (and not facilitate or support any persons to do in these manners):
											<br><br>
									<ol>
										<li>
											You shall not use SKOR Creative to perform or share unlawful, immoral, discriminative, or deceptive content, and that violates the rights of other persons;
										</li>
										<li>You shall not use viruses, malicious code, or do anything that may deactivate, overload, or damage the performance or appearance of SKOR Creative; and</li>
										<li>You shall not access or collect data from SKOR Creative by using automatic media (without Our prior permission) or try to access data to which You do not have access or permissions.</li>
									</ol>
										</li>
										<li>We may delete content You shared that violates these provisions and, if applicable, We will take any necessary action to your Account for the reasons described below. We can also suspend your Account if You repeatedly violate the applicable provisions. To help supporting the User and other Users, We encourage You to report any content or behavior that You believe violates Your rights (including intellectual property rights) and SKOR Creative’s terms and policies.</li>
									</ol>
								</li>
								<li>
									Permission You granted to SKOR Creative
									<br>
										<br>
									<ol>
										<li>
											SKOR Creative requires certain permission from You to provide the following services, namely:
											<br><br>
									<ol>
										<li>
											Permission to use content that You used and shared. You are the owner of the content that You created and shared at SKOR Creative, and this Terms of Services cannot take ownership of the content from Your hand. You have the freedom to share Your content with anyone and anywhere. However, for the Service provision, SKOR Creative requires You to give a number of permissions to use the content. For more details, when You share, post or upload any content within the scope of intellectual property rights (such as photos or video) in SKOR Creative as mentioned in Property and Proprietary Materials, You automatically grant non-exclusive, transferable, sub-licensable, royalty free, and worldwide license to host, use, distribute, change, run, copy, display or perform in public, translate, and make derivative works from your content. This means, for example, that when You share a photo in SKOR Creative, then You grant SKOR Creative permission to store, copy, and share it with other parties such as service providers that support such service.
										</li>
										<li>Permission to use name, profile picture, and information about Your actions with advertisements and sponsored content, in which You give us permission to use names profile picture, and information about actions that You have taken in SKOR Creative to or relating to any advertisements, campaigns and other sponsored content We show in SKOR Creative, without providing You any compensation whatsoever.</li>
										<li>Permission to update software that You use or download. When You download or use SKOR Creative, You grant permission to SKOR Creative to download and install any upgrades, updates, and additional features to improve, enhance and develop SKOR Creative.</li>
									</ol>
										</li>
									</ol>
								</li>
							<li>YOU ACKNOWLEDGE, CONSENT AND AGREE THAT WE RESERVE THE RIGHT TO ACCESS, SAVE AND PROVIDE INFORMATION AND CONTENT OF YOUR ACCOUNT THAT YOU HAVE UPLOADED, POSTED (SENT/DISPLAYED), OR IN ANY WAY EXIST IN SKOR CREATIVE IF IT IS REQUIRED BY THE APPLICABLE LAW OR THE SAVING AND PROVISION OF SUCH INFORMATION ARE REQUIRED FOR: (i) COMPLYING WITH ANY LEGAL PROCEEDING; (II) COMPLYING WITH LEGAL REQUIREMENTS ADOPTED BY LAW OR STATE, REGIONAL, OR LOCAL GOVERNMENT AUTHORITY; (III) IMPLEMENTING THIS TERMS OF SERVICES; (IV) RESPONDING TO ANY CLAIMS THAT A CONTENT VIOLATES THIRD PARTY RIGHTS; (V) RESPONDING TO YOUR REQUEST FOR CUSTOMER SERVICE; OR (VI) PROTECTING RIGHTS, OWNERSHIP OR PERSONAL SECURITY OF SKOR CREATIVE, THE USERS AND PUBLIC.</li>
							</ol>
						</li>
						<li>
							<strong>Restrictions on the Use of SKOR Creative’s Intellectual Property Rights</strong>
							<p>
								If You use any content protected by SKOR Creative’s intellectual property rights and available in the SKOR Creative’s application (e.g., images, design, video, or sound that SKOR Creative made available to You to be added to any content You create or share in SKOR Creative), SKOR Creative has all rights to that content (but not yours). You may only use SKOR Creative’s copyright or trademark (or similar mark) with prior written permission from SKOR Creative.
							</p>
						</li>
						<li>
							<strong>Account Suspension</strong>
							<br><br>
							<ol>
								<li>
									If You violate this Terms of Services, We can take action to Your Account for protecting the Service and the other Users, including by forbidding your access to your Account. SKOR Creative may also suspend Your account when you create anything that might be an unlawful threat to SKOR Creative, or when SKOR Creative is required to do so by law. If necessary, We will send a notification about the suspension of Your Account when You tried to access it.
								</li>
								<li>
									When We suspend Your Account, this Terms of Services shall cease to apply as an agreement between You and SKOR Creative, however this Terms of Services shall remain in effect for the other Users who are still registered in SKOR Creative.
								</li>

							</ol>
						</li>
						<li>
							<strong>Limitation of Liability</strong>
							<br><br>
							<ol>
								<li>
									SKOR Creative seriously seeks to provide SKOR Creative application and clear guidelines for anyone who uses it. However, SKOR Creative is provided in "as is" and "as available" basis without any guarantee whatsoever. We do not guarantee that the Service are always safe and free from any errors, nor guarantee that the Service function without interference, obstruction or defect. To the extent permitted by law, SKOR Creative also disclaims all guarantees, both implicitly and expressly, including implied guarantee regarding merchantability, suitability for specific purposes, ownership, and absence of violations. SKOR Creative is not capable to control the content from the Users when they are using SKOR Creative and SKOR Creative shall not be responsible for their actions or behavior (both online and offline) or any content they share (including offensive, inappropriate, indecent, unlawful, and other potentially disturbing content), even if You access it through our Service.
								</li>
								<li>
									SKOR Creative is not capable to predict issues that may arise in SKOR Creative. SKOR Creative liability is determined to the extent permitted by the applicable law, and SKOR Creative shall not be liable to you for any loss of profits, income, information or data, or consequential, special, indirect loss, extraordinary, punitive, or incidental damage arising out of or in relation hereto.
								</li>
								<li>
									In the event of any claim from any person against Us with regard to any actions, content or information in SKOR Creative, You shall indemnify, and hold Us harmless from and against all damages, losses, and expenses whatsoever (including all legal expenses and fees) related to the claim. In spite of Our rules on the Users behavior, We do not control or direct the Users actions in SKOR Creative and are not responsible for the content or information transmitted or distributed by the Users in SKOR Creative. We shall not be responsible for offensive, inappropriate, disturbing, unlawful content or information or that raises objections that You might find in SKOR Creative. We shall not be responsible for online or offline behavior performed by SKOR Creative users.
								</li>
								<li>
									IN ANY EVENT AND TO THE MAXIMUM EXTENT PERMITTED BY THE APPLICABLE LAW, WE, OUR AFFILIATES, EMPLOYEES, AGENTS, CONTRACTORS, LEGAL REPRESENTATIVES AND CONSULTANTS, SHALL NOT BE LIABLE EITHER DIRECTLY OR INDIRECTLY FOR ANY DAMAGES, LOSSES AND/OR VIOLATION OF LAW ARISING FROM THE USE OF SKOR CREATIVE OR ANY THIRD PARTY SITES LINKED TO SKOR CREATIVE, INCLUDING BUT NOT LIMITED TO ANY COMMUNICATION POSTED, UPLOADED, DISPLAYED OR TRANSMITTED BY THE USERS ON SKOR CREATIVE OR ANY THIRD PARTY SITES, INFORMATION OR SERVICES DISPLAYED ON SKOR CREATIVE, ANY INTERACTIONS BETWEEN THE USERS, ANY FORM OF YOUR PARTICIPATION IN ACTIVITIES HELD BY US.
								</li>
							</ol>
						</li>
						<li>
							<strong>Amendment</strong>
							<br><br>
							<ol>
								<li>
									SKOR Creative always works to improve services and develop new features to make SKOR Creative better for You and other Users. Therefore, SKOR Creative needs to update this Terms of Services from time to time in order to accurately reflect the SKOR Creative service.
								</li>
								<li>
									When We make material changes to the Terms of Services, We will provide notifications on SKOR Creative page that You can view before the changes take effect. We expect You to keep using SKOR Creative application, however if You do not agree with Our updated Terms of Services, You can stop using SKOR Creative at any time.
								</li>
								<li>
									Your continued use of the Service after We publish or notify You of any changes to this Terms of Services means that You agree to the updated Terms of Services of SKOR Creative.
								</li>
							</ol>
						</li>
						<li>
							<strong>Intellectual Property Rights</strong>
							<p>
								All content in SKOR Creative, including but not limited to information, text, graphics, layout, designs, logos, editorial content and other SKOR Creative’s proprietary material shall vest to SKOR Creative or its licensee and are protected by intellectual property law.
							</p>
						</li>
						<li>
							<strong>Severability</strong>
							<p>
								Each provision of this Terms of Services are severable and severed from each other, which are intended to be valid and enforceable. In the event of any part of this Terms of Services is deemed invalid or unenforceable, other provisions in this Terms of Services shall remain in full force and fully enforceable.
							</p>
						</li>
						<li>
							<strong>Dispute Resolution</strong>
							<br><br>
							<ol>
								<li>
									SKOR Creative seeks to provide clear rules in order to limit or prevent disputes between You and SKOR Creative. However, if any dispute arises, it is advisable to find solution and the prevailing law.
								</li>
								<li>
									Any disputes that may arise as a result of the implementation and/or termination/expiration of the Terms of Services shall be settled by the parties in deliberation to reach consensus. If after 30 (thirty) calendar days starting from the commencement of the deliberations the parties fail to reach consensus, the parties agree to settle each and all disputes through the South Jakarta District Court. You agree to submit to the personal jurisdiction of such court for the purpose of litigation of such claims.
								</li>
							</ol>
						</li>
						<li>
							<strong>Force Majeure</strong>
							<p>
								Without prejudice to the provisions of this Terms of Services, We declare that no party shall be responsible for any failure (either in whole or in part) and/or or delay in carrying out obligations under this Terms of Services and/or in complying with this Terms of Services to the extent that its performance of obligation is affected or hindered by a condition beyond its reasonable control, such as, but not limited to, natural disasters, acts of war or terrorism, riots, labor strike, government actions, and internet interference, which circumstances are beyond the control of either the User or SKOR Creative.
							</p>
						</li>
						<li>
							<strong>Miscellaneous</strong>
							<br><br>
							<ol>
								<li>
									This Terms of Services constitutes entire agreement between You and SKOR Creative relating to Your use of SKOR Creative.
								</li>
								<li>
									Failure of SKOR Creative to enforce this Terms of Services shall not be deemed as a waiver hereof. Any amendment to or waiver of any provisions in this Terms of Services shall be made in writing and signed by SKOR Creative.
								</li>
								<li>You shall not assign Your rights and/or obligations under this Terms of Services to any persons without SKOR Creative written approval.</li>
								<li>This Terms of Services do not grant any rights to third parties. All SKOR Creative’s rights and obligations under this Terms of Services may be freely assigned by SKOR Creative in the event of mergers, acquisitions, or asset sales, or law enforcement, or otherwise.</li>
								<li>If You have any applications supported by SKOR Engagement Platform technology, it shall be procured that You register it using different login id and e-mails for data security.</li>
								<li>Your input helps Us make the service better. However, please note that We might use it, and thus You hereby grant Us all rights, title and interest in and to such input or advice You provide in connection with SKOR Creative and/or the SKOR Creative’s Service, without the right to receive any compensation from Us. You represent and warrant that You have the authority to do so.</li>
								<li>SKOR Creative reserves all rights not expressly granted to You.</li>
							</ol>
						</li>
						<li>
							<strong>Governing Law</strong>
							<p>
								Any disputes, controversies or claims arising from or in connection with this Terms of Services shall be governed and interpreted in accordance with the laws of the Republic of Indonesia.
							</p>
						</li>
						<li>
							<strong>Language</strong>
							<p>
								This Terms of Services is made in 2 (two) versions, Indonesian and English versions. However, in the event of any conflicts, discrepancies and/or ambiguities between the Indonesian and English versions, the English version shall prevail.
							</p>
						</li>
				</ol>
			<p></p>

			<p>
				If You have any queries, comments, or concerns about the terms and conditions above, or otherwise require any help, please submit Your request to Us through <a href="mailto:support@skorpoints.com">support@skorpoints.com</a>.
			</p>
 
`;
